import React from "react";
import { Alert, Flex, Text, Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export default function SystemAlert({ alert, onClick }) {
  const navigate = useNavigate();

  return (
    <Alert radius="lg" mb="md" color={alert.color}>
      <Flex
        gap="xs"
        align={{ base: "flex-start", sm: "center" }}
        direction={{ base: "column", sm: "row" }}
      >
        <Text size="sm" fw={600} style={{ flexGrow: 1 }}>
          {alert.message}
        </Text>
        {alert.context && (
          <Button
            onClick={() => {
              if (onClick) {
                onClick();
              }

              if (alert.alt_path) {
                navigate(`/${alert.alt_path}`);
              } else {
                navigate(alert.path);
              }
            }}
            size="xs"
            color={alert.color}
            radius="lg"
          >
            Take me there
          </Button>
        )}
      </Flex>
    </Alert>
  );
}
